import {
  httpClient,
  queryClient,
  setTokens,
  type AuthTokenPair,
} from '@maxus/website/lib'

import { authQueryOptions } from './use-auth'

// 用一次性 ticket 换 tokenPair 并落地登录态（写 localStorage + 失效 auth 缓存）。
// 网页 ?ticket 回调（use-ticket-exchange）与桌面深链接回传（use-desktop-auth-callback）共用。
export const exchangeTicket = async (ticket: string): Promise<void> => {
  const res = await httpClient.post<AuthTokenPair>('/auth/ticket', { ticket })
  setTokens(res.data)
  await queryClient.invalidateQueries({ queryKey: authQueryOptions.queryKey })
}
